/* eslint-disable no-unused-vars */
import React, { useContext, useState } from 'react';
import { Box, Text, Icon, Container, useColorModeValue as mode } from '@chakra-ui/react';
import { FeatureGuard } from '@simplyanvil/npm-react-tools';
import { FiCheck } from 'react-icons/fi';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import { Navbar } from '../components/DefaultNavBar';
import { Footer } from '../components/chakraUIPro/Footer';
import { AuthStateContext } from '../contexts/AuthContext';
import { OrganisationStateContext } from '../contexts/OrganisationContext';
import Loading from '../components/Loading';

const Features = () => {
  const { organisations: orgs, currentOrganisation, isAuthenticated, isLoading } = useContext(AuthStateContext);
  const { organisation, organisations } = useContext(OrganisationStateContext);

  const scopes = ['usr:generate:jwt', 'usr:revoke:jwt', 'org:create:invoice'];
  const allowedScopes = ['org:create:invoice'];

  const router = useRouter();

  if (!isAuthenticated) {
    if (!isLoading && !isAuthenticated) {
      router.push('/');
    }
    return <Loading />;
  }

  return (
    <Box as='section' height='100vh' overflowY='auto'>
      <NextSeo title='Dashboard | eezi' description='' noindex nofollow />
      <Navbar />
      <Container pt={{ base: '8', lg: '12' }} pb={{ base: '12', lg: '24' }} maxWidth='8xl'>
        <Box>
          <FeatureGuard scopes={scopes} allowedScopes={allowedScopes}>
            <Box
              display='flex'
              flexDir='column'
              borderColor='white'
              borderWidth='1px'
              borderRadius='10px'
              padding='2rem'
              margin='2rem'
              alignItems='center'
              justifyContent='center'
            >
              <Icon as={FiCheck} color='green' boxSize='10' />
              <Text fontSize='xl' fontWeight='bold'>
                You have the correct scope to view this component
              </Text>
            </Box>
          </FeatureGuard>
        </Box>
      </Container>

      {/* Footer */}
      <Box bg={mode('black', 'gray.800')}>
        <Box maxW='8xl' mx='auto' px={8} textAlign='left'>
          <Footer />
        </Box>
      </Box>
    </Box>
  );
};

export default Features;
